import * as getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

export const getDefaultState = () => {
  return {};
};

// initial state
const state = getDefaultState();

export default {
  state,
  mutations,
  actions,
  getters
};
